module.exports = __webpack_public_path__ + "static/img/example.5921bba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skillTutor/example.png
// module id = 5/KP
// module chunks = 1